<c-dropdown alignment="end" variant="nav-item" *ngIf="(tasks$ | async)?.length > 0">
  <button cButton color="" [caret]="false" cDropdownToggle class="py-0 position-relative">
    <svg cIcon name="cilBell" size="lg"></svg>
    <span *ngIf="(pendingTasksCount$ | async) > 0"
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
      {{ pendingTasksCount$ | async }}
    </span>
  </button>
  <ul cDropdownMenu class="pt-0 overflow-auto" style="max-height: 400px;">
    <li>
      <h6 cDropdownHeader class="bg-light fw-semibold py-2">Tarefas do Servidor</h6>
    </li>
    <!-- <li *ngIf="(tasks$ | async)?.length === 0">
      <a cDropdownItem class="text-center">
        <small>Nenhuma tarefa recente</small>
      </a>
    </li> -->
    <li *ngFor="let task of tasks$ | async">
      <a cDropdownItem routerLink="/tasks/{{ task.task_id }}">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="fw-semibold" [title]="task.task_name">{{ task.task_name }}</div>
            <small [ngClass]="getStatusClass(task.status)">
              <svg cIcon [name]="getStatusIcon(task.status)" size="sm" class="me-1"></svg>
              {{ getStatusDesc(task.status) }}
            </small>
            <div class="small text-muted">
              {{ task.updated_at | date:'dd/MM/yyyy HH:mm' }}
            </div>
          </div>
        </div>
      </a>
    </li>
    <!-- <li *ngIf="(tasks$ | async)?.length > 0"> -->
    <li>
      <hr cDropdownDivider />
    </li>
    <li>
      <div class="d-flex justify-content-between align-items-center px-3">
        <a routerLink="/tasks" cDropdownItem class="text-center">
          <strong>Ver todas as tarefas</strong>
        </a>
        <!-- Marca todas como lidas -->
        <small class="text-muted click" (click)="markAllAsRead()" cDropdownItem>
          <svg cIcon name="cilCheck" size="sm" class="me-1"></svg>
          Marca todas como lidas
        </small>
      </div>
    </li>
  </ul>
</c-dropdown>
